<form #newA="ngForm" name="newA" (ngSubmit)="onSubmit(newA)" id="newA" class="mt-4 mb-0">
  <div class="fieldset fieldset--lg">
    <label for="name" class="legend">Name <span class="requiredfield">*</span></label>
    <input class="text-field" required type="text" id="name" name="name" [(ngModel)]="this.assessmentItem.name" #name
      autofocus>
  </div>
  <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
    <div class="fieldset fieldset--lg flex-fill" *ngIf="!isEdit">
      <label for="adm" class="legend">Assessment Type <span class="requiredfield">*</span></label>
      <select class="text-field" ngModel name="deliveryMode" id="adm" #deliveryMode required>
        <option value="{{AssessmentDeliveryMode_UntimedAssessment}}">Untimed Assessment</option>
        <option value="{{AssessmentDeliveryMode_TimedAssessment}}">Timed Assessment</option>
      </select>
    </div>
    <div class="fieldset fieldset--lg flex-fill" [ngClass]="{'ml-md-3': !isEdit}" id="durationHolder"
      *ngIf="assessmentItem.timedType!='UntimedAssessment'">
      <label for="duration" class="legend">Duration (Minutes)</label>
      <input class="text-field" type="number" id="duration" name="duration" [(ngModel)]="this.assessmentItem.duration"
        #duration>
    </div>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="!isEdit">
    <label for="assessmentType" class="legend">Question Type <span class="requiredfield">*</span></label>
    <select class="text-field" ngModel name="assessmentType" id="assessmentType" #assessmentType [(ngModel)]="this.assessmentItem.questionType" required>
      <option value="{{QuestionType_MultipleChoice}}">Multiple Choice</option>
      <option value="{{QuestionType_LongText}}">Essay/Comprehension</option>
      <option value="{{QuestionType_FileUpload}}">File Upload</option>
    </select>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="this.assessmentItem.questionType === QuestionType_LongText">
    <label for="essayTextLimit" class="legend">Maximum Word Count</label>
    <input class="text-field" type="number" id="essayTextLimit" name="essayTextLimit" [(ngModel)]="this.assessmentItem.essayTextLimit" #essayTextLimit
    >
  </div>
  <div class="fieldset fieldset--lg">
    <label for="startt" class="legend">Start Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawStartTime" class="text-field" id="startt" name="startt"
      [(ngModel)]="this.assessmentItem.rawStartTime" #startt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawStartTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawStartTime></owl-date-time>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="endt" class="legend">Due Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawEndTime" class="text-field" id="endt" name="endt"
      [(ngModel)]="this.assessmentItem.rawEndTime" #endt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawEndTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0  m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawEndTime></owl-date-time>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>

  <div class="fieldset fieldset--lg">
    <label for="optional" class="legend">Optional</label>
    <select class="text-field" [(ngModel)]="this.assessmentItem.optional" #optional name="optional" id="optional">
      <option value="true" selected>
        Yes
      </option>
      <option value="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="weight" class="legend">Weight (%) <span class="requiredfield">*</span></label>
    <input class="text-field" required type="number" id="weight" max="100" name="weight"
      [(ngModel)]="this.assessmentItem.weight" #weight>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button type="submit" class="btn m-0" [disabled]="!newA.valid || freezePage_formSubmissionInProgress"
      *ngIf="!isEdit" id="crt-new-asmt">Save</button>
    <button type="submit" class="btn m-0" *ngIf="isEdit" [disabled]="!newA.valid || freezePage_formSubmissionInProgress"
      id="crt-new-asmt">Save</button>
    <button type="button" class="btn btn--warning m-0" *ngIf="isEdit" routerLink="/user/assessmentdetails"
      [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID,aid:this.assessmentItem.id}">Cancel</button>
    <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentconsole"
      [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID}" *ngIf="!isEdit">Cancel</button>
  </div>
</form>
